import classNames from 'classnames'

import { type ICommonField } from '@/app/types/common'
import { type InputEvent } from '@/pages/Dms/helper'

import style from './RegularField.module.scss'

interface IProps {
    entity: ICommonField
    onChange: (e: InputEvent) => void
    className?: string
    onSetIsTouched: () => void
    disabled?: boolean
}

export const RegularField = (props: IProps) => {
    const { entity, className, disabled, onChange, onSetIsTouched } = props
    const { name, value, error, isTouched, placeholder } = entity
    const isError = isTouched && !!error
    return (
        <div className={classNames(style.container, className && className)}>
            <div className={style.blockTitle}>
                <span>{name}</span>
            </div>
            <div className={style.inputWrapper}>
                <input
                    className={classNames(style.field, isError && style.fieldError)}
                    name={name}
                    value={value || ''}
                    onChange={onChange}
                    onFocus={onSetIsTouched}
                    placeholder={placeholder}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}
